import { SyntheticEvent, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";

import AccordionArrow from "@/app/assets/icons/accordion-arrow.svg";

import { useTranslation } from "react-i18next";

const Questions = () => {
  const { t } = useTranslation("landing");

  const questions = Array.from({ length: 6 }).map((_, i) => ({
    question: t(`question_accordion.${i}.question`),
    answer: t(`question_accordion.${i}.answer`),
  }));

  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <section id="faq">
      <Container
        maxWidth={"xl"}
        sx={{
          height: "100%",
        }}
      >
        <Stack direction="column" alignItems="center" mb={16}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              fontSize: "34px",
              color: "#0B1370",
              marginBottom: "40px",
            }}
          >
            {t("question_title")}
          </Typography>

          <Stack sx={{ width: "100%", maxWidth: "1000px" }}>
            {questions.map((item, idx) => (
              <Accordion
                key={idx}
                expanded={expanded === `panel${idx}`}
                onChange={handleChange(`panel${idx}`)}
                sx={{
                  marginBottom: "12px",
                  backgroundColor:
                    expanded === `panel${idx}` ? "#FFFFFF" : "#E6F1FF",
                  border:
                    expanded === `panel${idx}` ? "1px solid #E6F1FF" : "none",
                  borderRadius: "16px !important",
                  boxShadow:
                    expanded === `panel${idx}`
                      ? "0 0 10px rgba(0, 0, 0, 0.1)"
                      : "none",
                  transition: "background-color 0.3s ease, border 0.3s ease",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <Box
                      component="img"
                      src={AccordionArrow}
                      alt="AccordionArrow"
                      sx={{ transform: "rotate(180deg)" }}
                    />
                  }
                  aria-controls={`panel${idx}-content`}
                  id={`panel${idx}-header`}
                  sx={{
                    fontSize: "17px",
                    fontWeight: 600,
                    lineHeight: "23px",
                    padding: "24px",
                    maxWidth: "100%",
                    paddingBottom: expanded === `panel${idx}` ? "0" : "24px",
                    marginBottom: "0 !important",
                    color: "#0B1370",
                    borderRadius: "16px",
                    backgroundColor:
                      expanded === `panel${idx}` ? "#FFFFFF" : "#E6F1FF",
                    transition: "0.3s ease",
                  }}
                >
                  {item.question}
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    padding: "24px",
                    paddingTop: "0px",
                    fontSize: "13px",
                    fontWeight: "400",
                    lineHeight: "18px",
                    color: "#0B1370",
                  }}
                >
                  {item.answer}
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Stack>
      </Container>
    </section>
  );
};

export default Questions;
